import React from 'react';
import { X, Calendar } from 'lucide-react';

const AssetHistoryPanel = ({ editingAsset, setEditingAsset, assetHistory, setAssetHistory, historyLoading, setShowAssetHistory, formatHistoryDate, formatFieldName }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-bold">Change History</h2>
            <p className="text-gray-600 text-sm">{editingAsset.name}</p>
          </div>
          <button onClick={() => { setShowAssetHistory(false); setEditingAsset(null); setAssetHistory([]); }}
            className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>

        {historyLoading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto" style={{ borderColor: "#00C5CB" }}></div>
            <p className="text-gray-500 mt-4">Loading history...</p>
          </div>
        ) : assetHistory.length === 0 ? (
          <div className="text-center py-12">
            <Calendar className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No Changes Yet</h3>
            <p className="text-gray-500">This asset hasn't been modified since it was created.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {assetHistory.map((entry) => (
              <div key={entry.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className={`w-3 h-3 rounded-full ${entry.change_type === "created" ? "bg-green-500" : entry.change_type === "updated" ? "bg-blue-500" : entry.change_type === "deleted" ? "bg-red-500" : "bg-gray-500"}`}></div>
                    <div>
                      <h4 className="font-medium text-gray-900">{entry.change_summary}</h4>
                      <p className="text-sm text-gray-500">{formatHistoryDate(entry.created_at)}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-gray-900">{entry.user_name}</p>
                    <p className="text-xs text-gray-500">{entry.user_email}</p>
                  </div>
                </div>
                {entry.changes && entry.changes.length > 0 && (
                  <div className="space-y-2">
                    {entry.changes.map((change, i) => (
                      <div key={i} className="bg-gray-50 rounded-lg p-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-900">{formatFieldName(change.field_name)}</span>
                          <span className={`text-xs px-2 py-1 rounded-full ${change.change_type === "added" ? "bg-green-100 text-green-800" : change.change_type === "removed" ? "bg-red-100 text-red-800" : "bg-blue-100 text-blue-800"}`}>
                            {change.change_type}
                          </span>
                        </div>
                        <div className="mt-2 text-sm">
                          {change.change_type === "added" && <div className="text-green-700"><span className="font-medium">Added:</span> {change.new_value}</div>}
                          {change.change_type === "removed" && <div className="text-red-700"><span className="font-medium">Removed:</span> {change.old_value}</div>}
                          {change.change_type === "updated" && (
                            <div className="space-y-1">
                              <div className="text-red-700"><span className="font-medium">From:</span> {change.old_value || "(empty)"}</div>
                              <div className="text-green-700"><span className="font-medium">To:</span> {change.new_value || "(empty)"}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="mt-6 text-center">
          <button onClick={() => { setShowAssetHistory(false); setEditingAsset(null); setAssetHistory([]); }}
            className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">Close</button>
        </div>
      </div>
    </div>
  </div>
);

export default AssetHistoryPanel;
